import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M102 10c2.9 0 5.8.5 8.6 1.6l66 25.4c8.2 3.1 13.4 10.4 13.4 18.4V170c0 11.1-9.8 20-22 20h-67.2c2.3-.1 4.4-1 6.1-2.6 1.7-1.5 2.8-3.6 3.1-5.8l.1-1.2V39.5c0-.6-.1-1.3-.2-1.9-1-4.8-5.6-8-10.6-7.6l-1.3.2-18 3.4V30c0-11 9.9-20 22-20zm-2.3 48c.2.7.3 1.5.3 2.2v119.6c0 1.3-.2 2.6-.7 3.9-.5 1.2-1.2 2.3-2.2 3.3-.9.9-2 1.7-3.3 2.2-1.2.5-2.5.8-3.9.8H20c-1.3 0-2.6-.3-3.9-.8-1.2-.5-2.3-1.3-3.3-2.2-.9-.9-1.7-2.1-2.2-3.3-.5-1.2-.7-2.5-.7-3.9V76c0-4.8 3.3-8.9 7.8-9.9l70-15.8c1.3-.3 2.6-.3 3.9-.1 1.3.2 2.5.7 3.7 1.4 1.1.7 2.1 1.6 2.8 2.7.8 1.1 1.4 2.4 1.6 3.7zm-38.3 54.9H48.6c-3.1 0-6.2 1.2-8.5 3.2-2.4 2.1-3.9 5-4.2 8.1l-.1 1.5v38.6h38.6v-38.6c0-3.4-1.4-6.7-3.8-9.1-2.5-2.4-5.8-3.7-9.2-3.7z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}